import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteRoom",
  tabindex: "-1",
  "aria-labelledby": "deleteRoom",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteRoom"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-center my-3" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = {
  class: "modal fade",
  id: "deleteRoomSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteRoomSuccess",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "modal-dialog" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteRoom"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_15 = { class: "d-flex justify-content-center my-3" }
const _hoisted_16 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import { onMounted, ref } from 'vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  talkRoomId: String,
  talkRoomName: String,
  paramGetTalkRooms: Object,
},
  setup(__props) {

const props = __props

const store = useStore()
const deleteFailed = ref<boolean>(false)
const loadingDelete = ref<boolean>(false)


// 2022/09/12 TienNV Fix double click button confirm delete talkRoom
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('deleteRoom'))
  modalSuccess.value = new Modal(document.getElementById('deleteRoomSuccess'))
})

const DeleteRoom = async () => {
  loadingDelete.value = true
  try {
    const response = await groupsService.deleteTalkRoomApi(props.talkRoomId)
    if (response?.status === 200) {
      deleteFailed.value = false
      // 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SO10 (Ph2-R20220930)
      const dataTalkRoom = await groupsService.getListTalkRoom(props.paramGetTalkRooms.id, props.paramGetTalkRooms.params)
      store.dispatch(GROUPS_STORE.ACTIONS.DELETE_TALK_ROOM, { id: props.talkRoomId, dataTalkRoom: dataTalkRoom.data })
    } else {
      deleteFailed.value = true
    }
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loadingDelete.value = false
    }, 2000)
  } catch (error) {
    deleteFailed.value = true
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loadingDelete.value = false
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SO10headerDelete')), 1),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)('talkRoomName')) + " : " + _toDisplayString(__props.talkRoomName), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                class: "me-2",
                size: 'small',
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: '削除する',
                onClick: DeleteRoom,
                loading: loadingDelete.value,
                disabled: loadingDelete.value,
                size: 'small',
                className: 'fw-bold',
                type: 'secondary'
              }, null, 8, ["loading", "disabled"])
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(translate)('SO10headerDelete')), 1),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, _toDisplayString(deleteFailed.value ? _unref(translate)('SO10deleteTalkRoomErrorUser') : _unref(translate)('SO10deleteTalkRoomSuccess')), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2",
              size: 'small',
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})